import React from 'react'

class DetailPopupContainer extends React.Component {
  state = {
    isDetailPopupOpen: false,
    openingDetailId: undefined,
    isRefetchItems: false,
    searchArchived: false,
  }

  handleOpenDetailPopup = (id, searchArchived = false) =>
    this.setState({
      ...this.state,
      isDetailPopupOpen: true,
      openingDetailId: id,
      searchArchived: searchArchived,
    })

  handleCloseDetailPopup = () => {
    this.setState({
      ...this.state,
      isDetailPopupOpen: false,
      openingDetailId: undefined,
    })
  }

  handleRefetchItemStart = () =>
    this.setState({ ...this.state, isRefetchItems: true })
  handleRefetchItemSuccess = () =>
    this.setState({ ...this.state, isRefetchItems: false })

  render() {
    const { isDetailPopupOpen, openingDetailId, isRefetchItems, searchArchived } = this.state
    const {
      children: Children,
      popupComponent: Popup,
      onConfirm,
      ...rest
    } = this.props
    return (
      <div>
        <Popup
          {...rest}
          onConfirm={onConfirm}
          isOpen={isDetailPopupOpen}
          onClose={this.handleCloseDetailPopup}
          detailId={openingDetailId}
          searchArchived={searchArchived}
          onRefetchStart={this.handleRefetchItemStart}
        />
        <Children
          {...rest}
          onOpenDetailPopup={this.handleOpenDetailPopup}
          isRefetchItems={isRefetchItems}
          onRefetchSuccess={this.handleRefetchItemSuccess}
        />
      </div>
    )
  }
}

export const withDetailPopupProvider =
  (component, popupComponent) => (props) => (
    <DetailPopupContainer
      {...props}
      children={component}
      popupComponent={popupComponent}
    />
  )
